// extracted by mini-css-extract-plugin
export var auto = "_36-1";
export var spinner = "_36-0";